export const azureRegionsRouteLinks = {
    root: "/azure-regions",
    create: "/azure-regions/create",
    azureRegion: (id: string) => ({
        root: `/azure-regions/${id}`,
        tasks: `/azure-regions/${id}/tasks`
    })
};
